import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useContext } from 'react';
import { FaPlus } from 'react-icons/fa';
import { UsuarioContext } from '../../UsuarioContext';
import { usuarioModais } from '../modal/usuarioModais';

const UsuarioFab = ({ onDelete, onCreate }) => {
  const [selecao] = useContext(UsuarioContext).selecao;
  const [tipoSelecao] = useContext(UsuarioContext).tipoSelecao;

  const existeSelecionados = selecao.length > 0 || tipoSelecao !== 'NENHUM';

  const triggerCreate = async (modal) => {
    onCreate(modal);
  };

  const triggerDelete = () => {
    onDelete({ ids: selecao, q: '', tipoSelecao });
  };

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'delete',
      tooltip: 'Excluir',
      show: permissaoUtils.usuario().excluir && existeSelecionados,
      onClick: triggerDelete,
    },
    {
      icon: <FaPlus />,
      name: 'createUsuario',
      tooltip: 'Cadastrar',
      show: permissaoUtils.usuario().cadastrar,
      onClick: () => triggerCreate(usuarioModais.cadastroUsuario),
    },
  ];

  return <TableActions actions={actions} />;
};

export default UsuarioFab;
